module.exports = __webpack_public_path__ + "img/newfun-01.c789ec54.svg";